<script setup>
/**
 * The key that presses a button, drawn on it: `Esc` beside a close cross, `N`
 * on the Add button, `⌘ ↵` on a sheet's Save — always to the right of the
 * icon or word it goes with. Hidden on a touch screen (a coarse pointer),
 * where it would only be noise.
 */
import { computed } from 'vue'
import { formatCombo } from '../../lib/shortcuts'

const props = defineProps({
  combo: { type: String, required: true },
})
const caps = computed(() => formatCombo(props.combo))
</script>

<template>
  <span class="kbd-hint kbd-inline" aria-hidden="true" data-kbd>
    <!-- The letter is drawn by CSS (attr(data-cap)), not written: a key cap is
         not part of a button's name, its text, or anything copied off it. -->
    <kbd v-for="(cap, i) in caps" :key="i" :data-cap="cap" />
  </span>
</template>
